import {Grid, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {
  Body,
  CommentInput,
  DoorCodeInput,
  EntranceInput,
  FlatInput,
  FloorInput,
  ToggleTitle,
} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {AddressSuggest} from '../AddressSuggest/AddressSuggest'
import {usePointAddress} from './hooks'
import {Props} from './types'

export function PointAddress(props: Props): React.ReactElement {
  const {isDetailsVisible, toggleDetailsVisibility, names, name, pointType, pointLocation, dataTestId} = usePointAddress(props)

  return (
    <Body
      lead={
        <>
          <Typography group="tight" mt="s" thickness="medium" variant="body2">
            {i18n('cargo.create.address.address', 'Адрес')}
          </Typography>
          <ToggleTitle
            data-e2e="address-details-opener"
            isOpened={isDetailsVisible}
            onClick={toggleDetailsVisibility}
            title={i18n('cargo.create.address.details', 'Детали')}
          />
        </>
      }
      tail={
        <Grid container>
          <Grid xs={12} item>
            <AddressSuggest commentName={names._comment} data-testid={dataTestId} location={pointLocation} name={name} pointType={pointType} />
          </Grid>
          {isDetailsVisible && (
            <Grid xs={12} item>
              <Grid size="s" container>
                <Grid xs={3} item>
                  <EntranceInput
                    data-testid={`porch_${names.porch}`}
                    name={names.porch}
                    names={{
                      logName: names.log,
                      locationName: names.location,
                      fullName: names.fullName,
                      shortName: names.shortName,
                    }}
                  />
                </Grid>
                <Grid xs={3} item>
                  <DoorCodeInput data-testid={`doorCode_${names.doorCode}`} name={names.doorCode} />
                </Grid>
                <Grid xs={3} item>
                  <FloorInput data-testid={`floor_${names.floor}`} name={names.floor} />
                </Grid>
                <Grid xs={3} item>
                  <FlatInput data-testid={`flat_${names.flat}`} name={names.flat} />
                </Grid>
              </Grid>
              <Grid xs={12} item>
                <CommentInput data-testid={`comment_${names.comment}`} name={names.comment} />
              </Grid>
            </Grid>
          )}
        </Grid>
      }
    />
  )
}
